// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../../cms/imageLarge.fragment.generated';
export const AvatarStackItemFragmentDoc = gql`
    fragment avatarStackItem on AvatarStackItem {
  __typename
  image {
    ...imageLarge
  }
}
    ${ImageLargeFragmentDoc}`;